<template>

    <div>

        <div class="row">
            <div class="col-24 col-md-12">

                <h3>Skicka länk till webappen</h3>

                <div class="custom-form-section">
                    <div class="custom-info pt-0 mb-4">Skicka en notis med länk till webappen, om den anställde behöver lägga den på hemskärmen igen och logga in. T ex vid byte av telefon.</div>

                    <button-app-url :employee="employee">
                        Skicka länk
                    </button-app-url>
                </div>

                <h3>Återställ lösenordet</h3>

                <div class="custom-form-section">
                    <div class="custom-info pt-0 mb-4">Skicka länk för att återställa lösenordet till den anställde.</div>

                    <button-restore-password :employee="employee">
                        Återställ lösenordet
                    </button-restore-password>
                </div>

            </div>

            <div class="col-24 col-md-12">

                <h3>Inaktivera kontot</h3>

                <div class="custom-form-section">
                    <div class="custom-info pt-0 mb-4">Inaktivera kontot tillfälligt. Detta gör att den anställde inte kan logga in, boka eller registrera klipp i sin webapp. Det kan återaktiveras vid behob.</div>

                    <button-disable-account :employee="employee" @refresh="$emit('close')">
                        <span v-if="employee.disabled_at">Återaktivera kontot</span>
                        <span v-else>Inaktivera kontot</span>
                    </button-disable-account>
                </div>

                <h3>Radera kontot</h3>

                <div class="custom-form-section">
                    <div class="custom-info pt-0 mb-4">Radera kontot helt, och rensa all persondata. En rad kommer att ligga kvar i listan, men namn, kontaktuppgifter, anställningsnumemr och annan persondata försvinner.</div>

                    <button-delete-account :employee="employee" @refresh="$emit('close')">
                        Radera kontot
                    </button-delete-account>
                </div>

            </div>

        </div>

    </div>

</template>

<script>

import buttonAppUrl from './button-app-url'
import buttonRestorePassword from './button-restore-password'
import buttonDisableAccount from './button-disable-account'
import buttonDeleteAccount from './button-delete-account'

export default {

    components: {
        buttonAppUrl,
        buttonRestorePassword,
        buttonDisableAccount,
        buttonDeleteAccount
    },

    props: {
        employee: {
            required: true
        }
    },

    data () {
        return {
        }
    }

}
</script>
